import React from 'react'

// Chart-type picker thumbnail: two ribbons flowing from a left column of nodes
// into a right one. Drawn at the same 72x56 size and palette as the other
// freeform chart-type icons.
export const SankeyIcon: React.FC = () => (
  <svg
    width="72"
    height="56"
    viewBox="0 0 72 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="56" rx="4" fill="white" />
    <path
      d="M18 10C36 10 36 30 54 30V42C36 42 36 22 18 22Z"
      fill="#DCE3ED"
      stroke="#4F72A4"
      strokeWidth="1"
    />
    <path
      d="M18 28C36 28 36 12 54 12V22C36 22 36 38 18 38Z"
      fill="#95AAC8"
      fillOpacity="0.8"
      stroke="#4F72A4"
      strokeWidth="1"
    />
    <rect x="12" y="10" width="6" height="28" rx="1" fill="#4F72A4" />
    <rect x="54" y="12" width="6" height="30" rx="1" fill="#4F72A4" />
  </svg>
)
